import React from 'react';
import { type BuyerLayoutProps } from 'shop-ui/types';
import { getDynamicImageSource } from 'libs/url';

interface CarouselProps extends BuyerLayoutProps<Product> {}

export const Carousel: React.FC<CarouselProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const source = getDynamicImageSource(product.medias?.[0]?.src, 0, 0);

    return (
        <div className="skeleton skeleton--ssr skeleton--full">
            <img className="ssr-hidden" src={source.src} alt={product.name} />
        </div>
    );
};
